import { useCallback } from 'react';
import F7Event         from '../app/events/f7_event';


export default function useDialog({ title = '', content = '', buttons = [] }) {

  const openDialog = useCallback(() => {

    document.dispatchEvent(new F7Event(app => {
      const dialog = app.dialog.create({
        title,
        content,
        buttons
      });

      dialog.open();
    }));

  }, [ buttons, content, title ]);

  return openDialog;
}
